import * as net from "net";
var idCounter = 0;
function createRegistry() {
  return {
    servers: /* @__PURE__ */ new Map(),
    routes: /* @__PURE__ */ new Map()
  };
}
function checkServerAlive(server) {
  return new Promise(function(resolve) {
    var socket = new net.Socket();
    var timeout = setTimeout(function() {
      socket.destroy();
      resolve(false);
    }, 1e3);
    socket.on("connect", function() {
      clearTimeout(timeout);
      socket.destroy();
      resolve(true);
    });
    socket.on("error", function() {
      clearTimeout(timeout);
      socket.destroy();
      resolve(false);
    });
    socket.connect(server.port, "127.0.0.1");
  });
}
async function pruneDeadServers(state, onPruned) {
  var servers = getAllServers(state);
  var prunedCount = 0;
  var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = void 0;
  try {
    for (var _iterator = servers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var server = _step.value;
      var alive = await checkServerAlive(server);
      if (!alive) {
        unregisterServer(state, server.id);
        onPruned === null || onPruned === void 0 ? void 0 : onPruned(server);
        prunedCount++;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
  return prunedCount;
}
function registerServer(state, opts) {
  var id = `server-${++idCounter}`;
  var registration = {
    id,
    port: opts.port,
    bundleId: opts.bundleId,
    root: opts.root,
    registeredAt: Date.now()
  };
  state.servers.set(id, registration);
  return registration;
}
function unregisterServer(state, id) {
  var deleted = state.servers.delete(id);
  var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = void 0;
  try {
    for (var _iterator = state.routes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var [key, route] = _step.value;
      if (route.serverId === id) {
        state.routes.delete(key);
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
  return deleted;
}
function findServersByBundleId(state, bundleId) {
  var matches = [];
  var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = void 0;
  try {
    for (var _iterator = state.servers.values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var server = _step.value;
      if (server.bundleId === bundleId) {
        matches.push(server);
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
  return matches;
}
function findServerById(state, id) {
  return state.servers.get(id);
}
function setRoute(state, key, serverId) {
  var binding = {
    key,
    serverId,
    createdAt: Date.now()
  };
  state.routes.set(key, binding);
  return binding;
}
function getRoute(state, key) {
  return state.routes.get(key);
}
function clearRoute(state, key) {
  return state.routes.delete(key);
}
function getAllServers(state) {
  return Array.from(state.servers.values());
}
function getAllRoutes(state) {
  return Array.from(state.routes.values());
}
function touchServer(state, id) {
  var server = state.servers.get(id);
  if (server) {
    server.lastActiveAt = Date.now();
    return true;
  }
  return false;
}
function getLastActiveServer(state) {
  var lastActive = null;
  var maxTime = 0;
  var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = void 0;
  try {
    for (var _iterator = state.servers.values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var server = _step.value;
      var activeTime = server.lastActiveAt || server.registeredAt;
      if (activeTime > maxTime) {
        maxTime = activeTime;
        lastActive = server;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
  return lastActive;
}
export {
  checkServerAlive,
  clearRoute,
  createRegistry,
  findServerById,
  findServersByBundleId,
  getAllRoutes,
  getAllServers,
  getLastActiveServer,
  getRoute,
  pruneDeadServers,
  registerServer,
  setRoute,
  touchServer,
  unregisterServer
};
//# sourceMappingURL=registry.js.map
